module.exports = __webpack_public_path__ + "img/download-report.4a57672e.svg";